import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/Home.vue'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页', icon: '/images/side/boss.png', activeIcon: '/images/side/boss1.png' }
      },

      {
        path: 'ai-skills',
        name: 'AiSkills',
        component: () => import('@/views/AiSkills.vue'),
        meta: { title: 'AI 技能', icon: '/images/side/smart.png', activeIcon: '/images/side/smart1.png' }
      },
      {
        path: 'ai-employee',
        name: 'AiEmployee',
        component: () => import('@/views/AiEmployee.vue'),
        meta: { title: 'AI 员工', icon: '/images/side/ai-emp.png', activeIcon: '/images/side/ai-emp1.png' }
      },
      {
        path: 'boss',
        name: 'Boss',
        component: () => import('@/views/Boss.vue'),
        meta: { title: 'BOSS直达', icon: '/images/side/boss.png', activeIcon: '/images/side/boss1.png', requiresAuth: true }
      },
      {
        path: 'geo',
        name: 'Geo',
        component: () => import('@/views/Geo.vue'),
        meta: { title: 'GEO', icon: '/images/side/sell.png', activeIcon: '/images/side/sell1.png', hidden: true }
      },
      {
        path: 'ai-phone',
        name: 'AiPhone',
        component: () => import('@/views/AiPhone.vue'),
        meta: { title: 'AI 手机', icon: '/images/side/phone.png', activeIcon: '/images/side/phone1.png', hidden: true }
      },

      {
        path: 'expert',
        name: 'Expert',
        component: () => import('@/views/Expert.vue'),
        meta: { title: '专家咨询', icon: '/images/side/expert.png', activeIcon: '/images/side/expert1.png' }
      },

      {
        path: 'asset',
        name: 'Asset',
        component: () => import('@/views/Asset.vue'),
        meta: { title: '知产交易', icon: '/images/side/equity.png', activeIcon: '/images/side/equity1.png' }
      },
      {
        path: 'about-us',
        name: 'AboutUs',
        component: () => import('@/views/AboutUs.vue'),
        meta: { title: '关于我们', icon: '/images/side/icon-网页@2x.png', activeIcon: '/images/side/icon-网页@2x.png', hidden: true }
      },
      {
        path: 'history',
        name: 'History',
        component: () => import('@/views/History.vue'),
        meta: { title: '历史对话', icon: '/images/side/history.png', activeIcon: '/images/side/history.png', requiresAuth: true },
        children: [
          {
            path: '',
            name: 'HistoryDetail',
            component: () => import('@/views/History.vue'),
            props: true,
            meta: {
              title: '会话详情',
              icon: '📄',
              activeIcon: '📄'
            }
          }
        ]
      },
    ]
  },
  {
    path: '/quick-order',
    name: 'QuickOrder',
    component: () => import('@/views/QuickOrder.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { guest: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationRedirected') {
      return Promise.reject(err)
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationRedirected') {
      return Promise.reject(err)
    }
  })
}

router.onError((error) => {
  if (
    error.name === 'NavigationRedirected' ||
    error.message?.includes('Redirected') ||
    error.message?.includes('via a navigation guard')
  ) {
    return
  }
  console.error('Router error:', error)
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (token) {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    next()
  }
})

async function getConsultHistory() {
  try {
    const token = localStorage.getItem('token');
    if (!token) return [];

    const apiBaseUrl = process.env.VUE_APP_API_URL;

    const response = await axios.get(`${apiBaseUrl}/im/conversation/conversation/list`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data.data.records || [];
  } catch (error) {
    console.error('获取历史会话失败:', error);
    return [];
  }
}

async function addHistoryChildRoutes() {
  const historyRoute = routes[0].children.find(route => route.path === 'history');
  if (!historyRoute) return [];

  const historyData = await getConsultHistory();

  historyRoute.children = [];

  if (historyData.length > 0) {
    const employeeList = store.getters.employeeList || []
    historyData.forEach(item => {
      const sessionId = item.id || item.conversationId
      const matchedEmployee = employeeList.find(e => e.shopName === item.shop.shopTitle)
      const title = matchedEmployee ? matchedEmployee.name : '无标题'
      historyRoute.children.push({
        path: `item-${sessionId}`,
        name: `HistorySession${sessionId}`,
        component: () => import('@/views/History.vue'),
        props: true,
        meta: {
          title: title,
          icon: '📄',
          activeIcon: '📄',
          sessionId: sessionId
        }
      })
    })
  } else {
    historyRoute.children.push({
      path: 'none',
      name: 'HistoryNone',
      component: () => import('@/views/History.vue'),
      props: true,
      meta: {
        title: '暂无历史会话',
        icon: '📄',
        activeIcon: '📄'
      }
    });
  }

  return historyData;
}

export { addHistoryChildRoutes }

export default router
